module.exports = __webpack_public_path__ + "static/media/Elaine@2x.5e88ca78.png";